import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login",
  style: {"height":"100%","display":"flex","align-items":"center"}
}
const _hoisted_2 = { class: "flex items-center justify-center gap-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "panel-title cursor-pointer",
  style: {"margin-right":"20px"}
}
const _hoisted_5 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","gap":"8px"} }
const _hoisted_6 = { style: {"max-width":"250px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"12px","color":"#8a8f99"}
}
const _hoisted_8 = {
  key: 1,
  style: {"font-size":"12px","color":"#8a8f99"}
}
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center justify-left gap-2" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","gap":"8px"} }
const _hoisted_14 = { style: {"max-width":"250px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_15 = {
  key: 0,
  style: {"font-size":"12px","color":"#8a8f99"}
}
const _hoisted_16 = {
  key: 1,
  style: {"font-size":"12px","color":"#8a8f99"}
}
const _hoisted_17 = {
  key: 0,
  style: {"border-bottom":"1px solid #e5e5e5","margin":"10px 0"}
}

import { ElButton, ElPopover, ElIcon, ElMessageBox } from 'element-plus'
import { User, ArrowDownBold, Select } from '@element-plus/icons-vue'
import { ref, computed, onMounted } from 'vue'
import { designTeam } from '@/api/affairs'
import { useMiscStore } from '@/stores/misc'

import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'team',
  setup(__props) {

const handleClick = () => {

    ; (window as any).openGlobalLogin?.()
}
const userStore = useUserStore()
const islogin = computed(() => userStore.isLoggedIn)
const handleLogout = () => {
    // @ts-ignore
    Auth.request.requestor({
        url: "/open/jssdk/init/user/logout",
        method: "get",
    }).then(() => {
        userStore.clearAuth()
        window.location.href = '/editor'
    })
}
// 使用 Pinia 中的团队状态（不落地本地存储）
const currentTeam = ref({})
const teamList = ref([])
const getTeamList = async () => {

    currentTeam.value = userStore.currentTeamInfo || {}

    //@ts-ignore
    teamList.value = (userStore.teamList || []) as any[]

}

const changeTeam = async (item: any) => {
    if (item.corp_code == (currentTeam.value as any)?.corp_code || !item.corp_code) {
        return
    }
    const miscStore = useMiscStore()
    ElMessageBox.confirm(
        '切换身份后，已打开的页面权限将刷新。请确保设计内容已妥善保存。',
        '是否切换',
        {
            confirmButtonText: '切换',
            cancelButtonText: '取消',
            type: 'warning',
            // center: true
        }
    ).then(() => {
        //@ts-ignore
        Auth.request.requestor({
            url: "/open/jssdk/user/team/switch",
            method: "post",
            data: {
                client_id: miscStore.getClientID(),
                team_corp_id: item.corp_code,
            }
        }).then(() => {
            window.location.reload()
        })
    }).catch(() => {
        // 用户点击"取消"或关闭对话框，不做任何操作
        return
    })

}
const handleInvite = () => {
    //@ts-ignore
    Auth.header.showInvitePopup();

    // Auth.invitePopup.toggleShow()
}
const handleUpgrade = () => {
    window.open('https://passport.aimano.xin/', '_blank')
}
// desginsdk.designOpt.LeftTabChange('image')
const teamManager = () => {
    const miscStore = useMiscStore()
    window.open('https://passport.manocode.cn/team-info/' + miscStore.getClientID(), '_blank')

}
onMounted(() => {
    if (!userStore.isLoggedIn) {
        return
    }
    getTeamList()
})

return (_ctx: any,_cache: any) => {
  return (islogin.value && teamList.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (islogin.value)
          ? (_openBlock(), _createBlock(_unref(ElPopover), {
              key: 0,
              placement: "top-end",
              width: 260,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    class: "w-[32px] h-[32px]",
                    src: currentTeam.value.icon_url || 'https://file.aimano.xin/passport/system/dc1a6a7fb61647139a3d9f56c41726ff.png',
                    alt: ""
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(currentTeam.value.name), 1),
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowDownBold), { color: "#8a8f99" })
                        ]),
                        _: 1
                      })
                    ]),
                    (currentTeam.value.employee_count)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "团队 " + _toDisplayString(currentTeam.value.employee_count || 0) + "人", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, "个人"))
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item",
                      key: item.corp_code,
                      onClick: ($event: any) => (changeTeam(item)),
                      style: {"text-align":"left"}
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                          class: "w-[32px] h-[32px]",
                          src: item.icon_url,
                          alt: ""
                        }, null, 8, _hoisted_12),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1),
                            (item.corp_code === currentTeam.value.corp_code)
                              ? (_openBlock(), _createBlock(_unref(ElIcon), { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Select), { color: "#2a66ff" })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (item.employee_count)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "团队 " + _toDisplayString(item.employee_count || 0) + "人 ", 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, "个人"))
                        ])
                      ])
                    ], 8, _hoisted_10))
                  }), 128)),
                  (currentTeam.value.corp_code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                    : _createCommentVNode("", true),
                  (currentTeam.value.corp_code)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "item",
                        onClick: handleInvite
                      }, "邀请成员"))
                    : _createCommentVNode("", true),
                  (currentTeam.value.corp_code)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "item",
                        onClick: teamManager
                      }, "团队管理"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})